import React from 'react';
import PropTypes from 'prop-types';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import EditableAdvanceTableWrapper from 'components/common/advance-table/EditableAdvanceTableWrapper';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceGridHeader from './AdvanceGridHeader';
import _ from 'lodash';

const EditGridPanel = ({
  form,
  panel,
  columns,
  rows,
  buttonClick,
  embedBadges
}) => {
  const [data, setData] = React.useState(rows);
  const [originalData] = React.useState(data);
  const [skipPageReset, setSkipPageReset] = React.useState(false);

  //Dispatch afterEdited;
  const afterCellEdited = (column, oldRow, row) => {
    form.eventTarget.dispatchEvent(
      new CustomEvent('form-event', {
        detail: {
          event: 'afterCellEdited',
          panel,
          form,
          data: { column, oldRow, row }
        }
      })
    );
  };

  // We need to keep the table from resetting the pageIndex when we
  // Update data. So we can keep track of that flag with a ref.

  // When our cell renderer calls updateMyData, we'll use
  // the rowIndex, columnId and new value to update the
  // original data
  const updateMyData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    setSkipPageReset(true);
    setData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          const n_row = {
            ...old[rowIndex],
            [columnId]: value
          };
          afterCellEdited(columnId, old[rowIndex], n_row);
          return n_row;
        } else {
          return row;
        }
      })
    );
  };

  // After data chagnes, we turn the flag back off
  // so that if data actually changes when we're not
  // editing it, the page is reset
  React.useEffect(() => {
    setSkipPageReset(false);
    form.eventTarget.dispatchEvent(
      new CustomEvent('form-event', {
        detail: {
          event: 'afterDataChanged',
          panel,
          form,
          data
        }
      })
    );
  }, [data]);

  // Let's add a data resetter/randomizer to help
  // illustrate that flow...
  panel.resetData = () => setData(originalData);
  panel.addRow = function (values) {
    // If values is an object or array
    if (_.isObjectLike(values)) {
      setData(_.concat(data, values));
    } else if (panel.getNewRow) {
      setData(_.concat(data, panel.getNewRow()));
    } else {
      setData(_.concat(data, {}));
    }
  };

  panel.currentRows = data;

  return (
    <EditableAdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      pagination
      perPage={10}
      updateMyData={updateMyData}
      skipPageReset={skipPageReset}
    >
      <AdvanceGridHeader
        table
        buttons={panel.buttons}
        buttonExecuter={buttonClick}
        badges={embedBadges}
      />
      <AdvanceTable
        table
        headerClassName="bg-200 text-900 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0 overflow-hidden'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowCount={data.length}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
        />
      </div>
    </EditableAdvanceTableWrapper>
  );
};

EditGridPanel.propTypes = {
  form: PropTypes.object,
  panel: PropTypes.object,
  rows: PropTypes.array,
  columns: PropTypes.array,
  buttonClick: PropTypes.func,
  embedBadges: PropTypes.array
};

export default EditGridPanel;
